export default {"src":"/_next/static/media/set-a-password.8e2f8a4b.svg","height":58,"width":87};